<template>
  <MultiSelect
    v-if="options"
    v-model="selectedMakes"
    :options="options"
    :multiple="true"
    :show-labels="false"
    :close-on-select="false"
    :clear-on-select="false"
    :allow-empty="true"
    :group-select="true"
    track-by="make"
    @input="changeMakes"
    placeholder="Select makes"
    :hide-selected="true"
    label="name"
    :searchable="true"
    :preserve-search="true"
  >
    <span slot="noResult">No makes found</span>
    <span slot="noOptions">List is empty</span>
  </MultiSelect>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'StockCompareSellerSelect',
  components: { MultiSelect: () => import('vue-multiselect') },
  props: {
    primary: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectedMakes: []
    }
  },
  computed: {
    ...mapGetters('stockcompare/dashboard', ['makes']),
    options() {
      return this.makes
    },
    selectedMakes: {
      get() {
        const currentMakes = this.primary ? this.myMakes : this.competitorMakes
        return Array.isArray(currentMakes)
          ? currentMakes
          : currentMakes
          ? [currentMakes]
          : []
      },
      set(value) {
        this.changeMyMake({ primary: this.primary, value })
      }
    }
  },

  methods: {
    ...mapActions('stockcompare/dashboard', ['changeMyMake']),
    changeMakes(values) {
      this.changeMyMake({ primary: this.primary, value: values })
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="sass">
.multiselect
  min-width: 16rem
  max-width: 100%

  .multiselect__tag
    background: #19A5CC
    color: white

  .multiselect__tag-icon:hover
    background: #2366d1

  .multiselect__option--selected
    background: #f5f5f5
    color: #4a4a4a
    font-weight: bold

    &.multiselect__option--highlight
      background: #e8f4fd
      color: #3273dc

  .multiselect__option--highlight
    background:  #19A5CC
    color: white
</style>
